// Upgrade optional components when rendered, including later Shopify section swaps.
const registry = document.getElementById('sr-component-modules');
if (registry) {
  const modules = Object.entries(JSON.parse(registry.textContent));
  const requested = new Map();
  const purchaseControls = /product-form-component|add-to-cart-component|variant-picker|quick-add-component|product-price|product-inventory|price-per-item/;

  const scan = (root) => {
    if (!(root instanceof Element || root instanceof Document)) return;
    for (const [selector, url] of modules) {
      if (requested.has(url)) continue;
      if (!root.matches?.(selector) && !root.querySelector(selector)) continue;
      let hint;
      if (!purchaseControls.test(selector)) {
        hint = document.createElement('link');
        hint.rel = 'modulepreload';
        hint.href = url;
        hint.fetchPriority = 'low';
        document.head.append(hint);
      }
      const loading = import(url);
      requested.set(url, loading);
      loading.then(() => hint?.remove(), () => hint?.remove());
      loading.catch((error) => {
        requested.delete(url);
        console.error('SaturnRings component failed to load:', selector, error);
      });
    }
  };

  scan(document);
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) scan(node);
    }
  }).observe(document.body, { childList: true, subtree: true });
}
